export default "__VITE_ASSET__Be9Hg473__"